import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_EXHIBITION } from "graphql/query/exhibition-gql";
import { PageWrapDefault } from "components/layout";
import { useActiveMenuItem } from "components/use-hooks";
import Exhibition from "components/exhibition";
import ExhibitionRoute from "components/routes/exhibition/exhibition-route";
import Localize, { localizeByKey } from "components/service/localize";
import type { TExhibitionType } from "components/exhibition/helpers/exhibition-types-helper";


const ExhibitionPage: React.FC = () =>
{
  useActiveMenuItem([ "exhibition-types" ], [ "exhibition-types" ]);

  const { id } = useParams<{ id: string }>();
  const basePath = Exhibition.Const.basePath;
  const exhibitionID = id ? parseInt(id) : "create";

  const { data, loading } = useQuery<{ exhibitionType: TExhibitionType }>(GET_EXHIBITION, {
    skip: !exhibitionID,
    variables: {
      id: exhibitionID,
    },
  });


  const exhibitionType = data?.exhibitionType;

  const pageNavbar = [
    {
      label: localizeByKey("NAVBAR_PAGES.Label_Overview"),
      path: "",
    },
    {
      label: localizeByKey("NAVBAR_PAGES.Label_StandTypes"),
      path: "stand-types",
    },
    {
      label: localizeByKey("NAVBAR_PAGES.Label_Equipment"),
      path: "equipment",
    },
    {
      label: localizeByKey("NAVBAR_PAGES.Label_Flooring"),
      path: "flooring",
    },
  ];

  return (
    <PageWrapDefault
      className="page-exhibition"
      loading={loading}
      title={
        exhibitionID === "create" ? (
          <Localize>PAGES.Title_CreateExhibition</Localize>
        ) : !loading && exhibitionType ? (
          <Localize>{exhibitionType.title}</Localize>
        ) : (
          "Page 404"
        )
      }
      dataExist={exhibitionID === "create" ? true : !loading && exhibitionType !== undefined}
      pageNavbar={!loading && exhibitionType ? pageNavbar : undefined}
      staticPath={`${basePath}/${exhibitionID}`}
    >
      <ExhibitionRoute
        exhibition={exhibitionType}
      />
    </PageWrapDefault>
  );
};

export default ExhibitionPage;
